import axios from "axios";
import CONF from "@/Config.js";

const getInitialState = () => {
  const savedContents = localStorage.getItem('function_contents');
  
  return {
    contents: savedContents || '/* 함수를 여기에 작성하세요 */'
  };
};

const state = getInitialState();

const mutations = {
  updateContents(state, code) {
    state.contents = code;
    localStorage.setItem('function_contents', code);
  }
};

const actions = {
  // eslint-disable-next-line no-empty-pattern
  async loadFunctions({ }, { barcode }) {
    try {
      const token = localStorage.getItem("access_token");
      const response = await axios.get(`${CONF.API_URL}/textbook/editor/textbookContents/${barcode}/functions`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      //console.log(type, barcode);
      //console.log(response.data);
      return response.data;
    } catch (error) {
      console.error('함수 로드 실패:', error);
      throw error;
    }
  },

  // eslint-disable-next-line no-unused-vars, no-dupe-keys
  async saveFunctions({ commit }, { code, barcode }) {
    try {
      const token = localStorage.getItem("access_token"); 
      const response = await axios.post(`${CONF.API_URL}/textbook/editor/textbookContents/${barcode}/functions`, {
        code
      }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data;
    } catch (error) {
      console.error('함수 저장 실패:', error);
      throw error;
    }
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
}; 